// extracted by mini-css-extract-plugin
export var readonly = "_g9-1";
export var star = "_g9-0";